export const money = (n, d = 2) =>
  (n ?? 0).toLocaleString("en-US", { minimumFractionDigits: d, maximumFractionDigits: d });

export const usd = (n, d = 2) => `$${money(n, d)}`;

export const pct = (n) => `${n >= 0 ? "+" : ""}${(n ?? 0).toFixed(2)}%`;

export const signed = (n, d = 2) => `${n >= 0 ? "+" : "-"}$${money(Math.abs(n ?? 0), d)}`;

export const fmtPrice = (p) => {
  if (p == null) return "-";
  if (p < 10) return p.toFixed(5);
  return p.toLocaleString("en-US", { minimumFractionDigits: 2, maximumFractionDigits: 2 });
};

export const timeAgo = (iso) => {
  if (!iso) return "-";
  const d = new Date(iso);
  return d.toLocaleString("en-US", { month: "short", day: "numeric", hour: "2-digit", minute: "2-digit" });
};

export const clsx = (...a) => a.filter(Boolean).join(" ");

export const dirUp = (d) => ["buy", "call"].includes(d);
export const dirLabel = (d) => (dirUp(d) ? "BUY" : "SELL");
